export default __webpack_public_path__ + "static/media/playing-golf_016o.2f2c54c1.svg";